/*
 *   File : change-stage.js
 *   Author : https://evoqins.com
 *   Description : Change lead stage tab file
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { Fragment, useEffect, useState } from 'react';
import { Modal } from 'bootstrap';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';

//style
import Color from "../../../Style/color.scss";

//Custom components
import { CustomSelectBox } from '../../../Components/FormElements';
import { PrimaryButton } from '../../../Components/Buttons';
import { ConfirmModal } from '../../../Components/Modal';
import { APIService } from '../../../Service';

const ChangeStage = (props) => {

    const { id } = useParams();

    const [selectedStage, setSelectedStage] = useState(null);
    const [selectedStageError, setSelectedStageError] = useState("");

    const [confirm, setConfirm] = useState(false);
    const [status, setStatus] = useState(false);
    const [buttonLoader, setButtonLoader] = useState(false);

    useEffect(() => {
        if (props.data.lead_stage_id) {
            setSelectedStage({
                value: props.data.lead_stage_id,
                label: props.data.lead_stage_name
            })
        }
    }, [props.data]);

    useEffect(() => {
        setSelectedStageError("");
    }, [selectedStage]);

    useEffect(() => {
        if (confirm === true) {
            const confirm_modal = new Modal(document.getElementById('confirm-modal'));
            confirm_modal.show();
        }
    }, [confirm]);

    // handle save lead stage 
    const _handleSave = () => {
        if (selectedStage === null) {
            setSelectedStageError("Please select lead stage");
            return;
        }
        setConfirm(true);
    };

    // API - Update lead
    const _updateLead = () => {
        let is_post = true;
        let url = 'lead/update-lead';
        let data = {
            "lead_id": Number(id),
            "note": null,
            "note_id": null,
            "type": 2,
            "next_follow_up_date": null,
            "lead_stage_id": selectedStage.value
        };
        setButtonLoader(true);
        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setStatus(true);
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
            setButtonLoader(false);
        });
    };

    return (
        <Fragment>
            <div className='padding-32px-all min-vh-50'>
                <h4 className='mb-0 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                    Change lead stage
                </h4>

                <div className='padding-26px-top row'>
                    {/* Lead stage */}
                    <div className='col-4'>
                        <CustomSelectBox title='Lead stage'
                            placeholder='Select stage'
                            controlWidth='w-100'
                            required={true}
                            options={props.leadStage}
                            isSearchable={true}
                            borderColor={`0.031rem solid ${Color.arsenic}`}
                            padding="0.5rem 1rem"
                            value={selectedStage}
                            error={selectedStageError}
                            onChange={(data) => setSelectedStage(data)} />

                        <div className='pt-4 mt-2 text-end'>
                            <PrimaryButton name="Save"
                                paddingBlock="py-3 padding-70px-lr"
                                onClick={_handleSave} />
                        </div>
                    </div>
                </div>
            </div>

            {/* confirm modal */}
            {confirm === true &&
                <ConfirmModal title={status ? "Confirm successfully" : "Confirm stage change"}
                    description={status ? "The stage change has  been changed successfully." : "Are you sure you want to change the stage of this lead from Opportunity to Customer? This action will update the lead's status in the sales pipeline and may impact future follow-ups."}
                    status={status}
                    loader={buttonLoader}
                    handleClose={() => {
                        setTimeout(() => {
                            setConfirm(false);
                            setStatus(false);
                        }, 200);
                    }}
                    handleConfirm={() => _updateLead()}
                    handleSuccess={() => {
                        setTimeout(() => {
                            setConfirm(false);
                            setStatus(false);
                            // setSelectedStage(null);
                            props.handleUpdate();
                        }, 200);
                    }} />
            }
        </Fragment>
    )
}

export default ChangeStage;
